<template>
  <div>
    <chartjs-pie-card
      v-if="dataIsNotEmpty"
      :chart-data="chartData"
      :chart-options="chartOptions"
      style="/*min-height:475px*/"
    >
      <template slot="header">
        <div class="d-flex">
          <div class="card-title diligencePieChartTitle">Portfolio Status</div>
          <div
            class="d-flex"
            style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
            v-tooltip.top-end="toolTipInfo"
          >
            <img src="static/img/graphInfo.svg" class />
          </div>
        </div>
      </template>
    </chartjs-pie-card>
  </div>
</template>
<script>
import { vals, formatCurrency, subsetBackground } from "../../../util";
import { ChartjsPieCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
export default {
  name: "pie-status-chart-card",
  components: {
    [ChartjsPieCard.name]: ChartjsPieCard,
  },
  props: {
    cutoutPercentage: {
      type: Number,
      default: 65,
    },
  },
  data() {
    return {
      dataIsEmpty: true,
      datasets: [],
      labels: [],
      textCenterLabel: [],
      chartColors: {
        active: "#009DE0",
        ob: "#9358A2",
        exit: "#6D5BA4",
      },
    };
  },
  computed: {
    ...mapGetters("charts", ["statusChartData"]),
    chartData() {
      const self = this;
      let data = {
        labels: _.flatten(self.computedLabels),
        datasets: self.computedDataset,
      };
      return data;
    },
    chartOptions() {
      const self = this;
      // let d = self.chartData
      let options = {
        cutoutPercentage: this.cutoutPercentage,
        plugins: {
          doughnutlabel: {
            labels: this.textCenterLabel,
          },
        },
        circumference: 1 * Math.PI,
        rotation: 1 * Math.PI,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].toolTip_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                (data.datasets[toolTipItem.datasetIndex].data[
                  toolTipItem.index
                ] || "") +
                "%"
              );
            },
            footer: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].data_value[
                  toolTipItem.index
                ] || 0;
              return value > 1 ? `${value} Companies` : `${value} Company`;
            },
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            padding: 25,
          },
        },
        onClick: function (unused, toolTips) {
          let toolTipItem = toolTips[0];
          if (!_.isNil(toolTipItem)) {
            if (toolTipItem._datasetIndex === 0) {
              // only 'drill-down' if it is a primary value
              let data = toolTipItem._chart.data;
              let propertyValue =
                data.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              self.addDatasetForProperty(propertyValue, toolTipItem._index);
              let rightsDataValue =
                data.datasets[toolTipItem._datasetIndex].data_value[
                  toolTipItem._index
                ];
              let obj = {
                text: propertyValue,
                font: {
                  size: "12",
                  family: "custom-helvetica-medium,roboto",
                },
                color: "#050505",
              };
              let dataObj = {
                text: rightsDataValue,
                font: {
                  size: "25",
                  family: "custom-helvetica-medium,roboto",
                },
                color: "#050505",
              };
              let emptyLabel = {
                text: "  ",
                font: {
                  size: "14",
                  family: "custom-helvetica-medium,roboto",
                },
                color: "#050505",
              };
              self.textCenterLabel = [];
              self.textCenterLabel = [
                emptyLabel,
                emptyLabel,
                emptyLabel,
                emptyLabel,
                emptyLabel,
              ];
              self.textCenterLabel[5] = obj;
              self.textCenterLabel[6] = dataObj;
            } else if (toolTipItem._datasetIndex === 1) {
              // second tier
              // if label has 'Other' then we want to show table data
              let drillData = toolTipItem._chart.data;
              let drillPropertyValue =
                drillData.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              // make sure we have a path and that the path has 'Other' as its leaf
              if (drillPropertyValue.includes("/")) {
                let split = drillPropertyValue.split("/");
                let drillCompanyData = self.statusChartData[split[0].trim()];
                let actualCompany = drillCompanyData.find((item) => {
                  if (item.name == split[1].trim()) {
                    return item;
                  }
                });
                let account_id = self.$route.params.account_id;
                let workspace_id = self.$route.params.workspace_id;
                let ucid = actualCompany.ucid;
                self.$store.commit("temp/currentCompany", ucid);
                self.$router.push(
                  `/${account_id}/${workspace_id}/companyProfile/${ucid}`
                );
              }
            }
          }
        },
      };
      return options;
    },
    computedDataset() {
      return this.datasets;
    },
    computedLabels() {
      return this.labels;
    },
    dataIsNotEmpty() {
      return this.statusChartData.totalDataLength;
    },
    toolTipInfo() {
      return "The Active, Out of Business and exit numbers are derivatives from your portfolio page. We collect this data from Crunchbase and can be overwritten at any time. Exit includes companies that have returned to the fund. ";
    },
  },
  methods: {
    createPrimaryDataset() {
      const self = this;
      // only do check if there is data (and it is local)
      if (self.statusChartData.totalDataLength < 1) return;
      // do initial calculate for chart data
      let labels = [];
      let backgroundColors = [];
      let values = [];
      let values_p = [];
      let tooltipLabels = [];
      if (
        self.statusChartData &&
        self.statusChartData.active &&
        self.statusChartData.active.length > 0
      ) {
        labels.push("Active");
        values.push(self.statusChartData.active.length);
        values_p.push(
          (
            (self.statusChartData.active.length /
              self.statusChartData.totalDataLength) *
            100
          ).toFixed(2)
        );
        backgroundColors.push("#009DE0");
      }
      if (
        self.statusChartData &&
        self.statusChartData.ob &&
        self.statusChartData.ob.length > 0
      ) {
        labels.push("Out of Business");
        values.push(self.statusChartData.ob.length);
        values_p.push(
          (
            (self.statusChartData.ob.length /
              self.statusChartData.totalDataLength) *
            100
          ).toFixed(2)
        );
        backgroundColors.push("#9358A2");
      }
      if (
        self.statusChartData &&
        self.statusChartData.exit &&
        self.statusChartData.exit.length > 0
      ) {
        labels.push("Exit");
        values.push(self.statusChartData.exit.length);
        values_p.push(
          (
            (self.statusChartData.exit.length /
              self.statusChartData.totalDataLength) *
            100
          ).toFixed(2)
        );
        backgroundColors.push("#6D5BA4");
      }
      self.datasets = [];
      self.labels = [];
      let emptyLabel = {
        text: "  ",
        font: {
          size: "14",
          family: "custom-helvetica-medium,roboto",
        },
        color: "#050505",
      };
      self.textCenterLabel = [
        emptyLabel,
        emptyLabel,
        emptyLabel,
        emptyLabel,
        emptyLabel,
      ];
      self.textCenterLabel[5] = {
        text: "Total",
        font: {
          size: "14",
          family: "custom-helvetica-medium,roboto",
        },
        color: "#050505",
      };
      self.textCenterLabel[6] = {
        text: self.statusChartData.totalDataLength,
        font: {
          size: "25",
          family: "custom-helvetica-medium,roboto",
        },
        color: "#050505",
      };
      self.labels = labels;
      self.datasets.push({
        header_label: labels,
        data: values_p,
        data_value: values,
        backgroundColor: backgroundColors,
        toolTip_label: labels,
      });
    },
    addDatasetForProperty(value, index) {
      let valueModified;
      if (value == "Active") {
        valueModified = "active";
      }
      if (value == "Out of Business") {
        valueModified = "ob";
      }
      if (value == "Exit") {
        valueModified = "exit";
      }
      const self = this;
      let values = self.statusChartData[valueModified];
      let finalObj = { value: [], value_p: [], names: [] };
      let bgColors = [];
      values.map((item) => {
        finalObj.value.push(1);
        finalObj.value_p.push(((1 / values.length) * 100).toFixed(2));
        finalObj.names.push(item.name);
        bgColors.push(self.chartColors[valueModified]);
      });
      //if (index > 9) index = index - 10;
      //let bgColors = _.concat(subsetBackground(index), subsetBackground(index));
      // if (values.length <= bgColors.length) {
      //   // we want 'other' to be grey (default color) - remove colors so that other is 'empty'
      //   bgColors = _.slice(bgColors, 0, values.length - 1);
      // }
      // create the dataset...
      let dataset = {
        header_label: _.map(finalObj.names, (n) => {
          return valueModified + " / " + n;
        }),
        toolTip_label: _.map(finalObj.names, (n) => {
          return value + " / " + n;
        }),
        data: finalObj.value_p,
        data_value: finalObj.value,
        backgroundColor: bgColors,
      };
      // if there is already a second dataset, remove it
      if (self.datasets.length > 1)
        self.datasets = _.slice(self.datasets, 0, 1);
      // add new one
      self.datasets.push(dataset);
      self.datasets = _.without(self.datasets, undefined, null);
    },
  },
  mounted() {
    this.createPrimaryDataset();
  },
  watch: {
    statusChartData: {
      handler(newData) {
        if (newData) {
          this.createPrimaryDataset();
        }
      },
    },
  },
};
</script>